export default {"src":"/_next/static/media/telegram-black.d3349cd4.svg","height":16,"width":16};